// extracted by mini-css-extract-plugin
module.exports = {"m-map-loading":"MapLoading_m-map-loading__2g9lX","m-map-loading__content":"MapLoading_m-map-loading__content__25L9k"};